import React from "react";

const ConfirmModal = ({ isOpen, onClose, type, onSubmit }) => {
  if (!isOpen) return null;

  const isSkip = type === "skip";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-sm mx-auto p-6 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        >
          &times;
        </button>

        {/* Title */}
        <h2 className="text-lg font-semibold text-center mb-3">
           Confirm Submission
        </h2>

        {/* Description */}
        <p className="text-sm text-gray-600 text-center">
          {isSkip
            ? "Are you sure you want to leave the Motor Vehicle Injury form empty?"
            : "Are you sure you want to submit this form?"}
          <br />
          <span className="text-gray-500">
            {isSkip ? "" : "This action cannot be undone."}
          </span>
        </p>

        {/* Buttons */}
  <div className="mt-6 flex justify-center gap-4">
  {isSkip ? (
    <>
      <button
        onClick={onSubmit}
        className="px-4 py-2 rounded text-white bg-blue-600 hover:bg-blue-700"
      >
        Yes
      </button>
      <button
        onClick={onClose}
        className="px-4 py-2 rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
      >
        No
      </button>
    </>
  ) : (
    <>
      <button
        onClick={onClose}
        className="px-4 py-2 rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
      >
        Cancel
      </button>
      <button
        onClick={onSubmit}
        className="px-4 py-2 rounded text-white bg-blue-600 hover:bg-blue-700"
      >
        Submit
      </button>
    </>
  )}
</div>

      </div>
    </div>
  );
};

export default ConfirmModal;
